import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import { useListaAtendimentoActionsLoading } from 'view/atendimentos/list/hooks/useListaAtendimentoActionsLoading'

import { AutorizacaoAbsorventesModal } from './AutorizacaoAbsorventesModal'

interface UrlParams {
  cidadaoId: string
}

export function AutorizacaoAbsorventesListaAtendimentoModal() {
  const { stopLoading } = useListaAtendimentoActionsLoading()
  const { cidadaoId } = useParams<UrlParams>()
  const history = useHistory()

  useEffect(stopLoading, [stopLoading])

  const handleClose = () => {
    return history.push('/lista-atendimento')
  }

  return <AutorizacaoAbsorventesModal open cidadaoId={cidadaoId} onClose={handleClose} />
}
